import React from "react";
import { string, oneOfType, objectOf, number } from "prop-types";

const Star = ({ style, className }) => (
	<i
		style={{
			...style,
			display: "inline-block",
			fill: "currentColor",
		}}
		className={className}>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style={{
				width: "100%",
				height: "100%",
			}}
			viewBox="0 0 24 24">
			<path
				d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"
				style={{ fill: "currentcolor" }}
			/>
		</svg>
	</i>
);

Star.propTypes = {
	className: string,
	style: objectOf(oneOfType([string, number])),
};
Star.defaultProps = {
	className: "",
	style: {},
};
export default Star;
export { Star };
